// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"7e3a4566","496":"348e7f24"}[chunkId] + ".chunk.js";
};